import moment from 'moment';

function DateTimeCellRender() {}

DateTimeCellRender.prototype.init = function (params) {
    this.eGui = document.createElement('span');
    if (params.value !== "" || params.value !== undefined || params.value !== null) {
        var momentutc = moment.utc(params.value);
        momentutc.locale(params.fields.currentLanguage);

        this.eGui.innerHTML = momentutc.format("L") + " " + momentutc.format("LT");
    }
};

DateTimeCellRender.prototype.getGui = function () {
    return this.eGui;
};

export default DateTimeCellRender;


// WEBPACK FOOTER //
// ./src/components/table/cellRenderers/DateTimeCellRender.js